export type Color = {
  id: string;
  label?: string;
  value: string;
  subGroupId?: string;
};

export type ColorGroups = {
  id: string;
  label: string;
  colors: Color[];
  subGroups?: { id: string; label: string; hideDivider?: boolean; className?: string }[];
};

// // //to generate the unique color ids as earlier we used to save palette- prefix in the id
// const ALL_UNIQUE_COLOR_IDS: string[] = [
//   // From whiteBlack
//   'bg-transparent',
//   'bg-primary',
//   'bg-primary_inverse',

//   // From primaryColor (note: 'bg-secondary' appears twice but we only include once)
//   'bg-solid-secondary',
//   'bg-overlay',
//   'bg-darker',
//   'bg-dark',
//   'bg-strong',
//   'bg-medium',
//   'bg-mild',
//   'bg-quaternary',
//   'bg-tertiary',
//   'bg-secondary',
//   'bg-lightest',
//   'bg-brand-solid',
//   'bg-brand-darkest',
//   'bg-brand-darker',
//   'border-utility-brand-800',
//   'border-utility-brand-700',
//   'bg-brand-medium',
//   'bg-brand-mild',
//   'bg-brand-soft',
//   'bg-brand-tertiary',
//   'bg-brand-secondary',
//   'bg-brand-primary',
//   'border-palette-brand-25',
//   'border-palette-brand-secondary-600',
//   'border-palette-brand-secondary-950',
//   'border-palette-brand-secondary-900',
//   'border-palette-brand-secondary-800',
//   'border-palette-brand-secondary-700',
//   'border-palette-brand-secondary-500',
//   'border-palette-brand-secondary-400',
//   'border-palette-brand-secondary-300',
//   'border-palette-brand-secondary-200',
//   'border-palette-brand-secondary-100',
//   'border-palette-brand-secondary-50',
//   'border-palette-brand-secondary-25',
//   'border-palette-success-600',
//   'border-palette-success-950',
//   'border-palette-success-900',
//   'border-palette-success-800',
//   'border-palette-success-700',
//   'border-palette-success-500',
//   'border-palette-success-400',
//   'border-palette-success-300',
//   'border-palette-success-200',
//   'border-palette-success-100',
//   'border-palette-success-50',
//   'border-palette-success-25',
//   'border-palette-error-600',
//   'border-palette-error-950',
//   'border-palette-error-900',
//   'border-palette-error-800',
//   'border-palette-error-700',
//   'border-palette-error-500',
//   'border-palette-error-400',
//   'border-palette-error-300',
//   'border-palette-error-200',
//   'border-palette-error-100',
//   'border-palette-error-50',
//   'border-palette-error-25',
//   'border-palette-warning-600',
//   'border-palette-warning-950',
//   'border-palette-warning-900',
//   'border-palette-warning-800',
//   'border-palette-warning-700',
//   'border-palette-warning-500',
//   'border-palette-warning-400',
//   'border-palette-warning-300',
//   'border-palette-warning-200',
//   'border-palette-warning-100',
//   'border-palette-warning-50',
//   'border-palette-warning-25',

//   // From accentColors
//   'border-palette-lime-green-600',
//   'border-palette-lime-green-950',
//   'border-palette-lime-green-900',
//   'border-palette-lime-green-800',
//   'border-palette-lime-green-700',
//   'border-palette-lime-green-500',
//   'border-palette-lime-green-400',
//   'border-palette-lime-green-300',
//   'border-palette-lime-green-200',
//   'border-palette-lime-green-100',
//   'border-palette-lime-green-50',
//   'border-palette-lime-green-25',
//   'border-palette-teal-600',
//   'border-palette-teal-950',
//   'border-palette-teal-900',
//   'border-palette-teal-800',
//   'border-palette-teal-700',
//   'border-palette-teal-500',
//   'border-palette-teal-400',
//   'border-palette-teal-300',
//   'border-palette-teal-200',
//   'border-palette-teal-100',
//   'border-palette-teal-50',
//   'border-palette-teal-25',
//   'border-palette-cyan-600',
//   'border-palette-cyan-950',
//   'border-palette-cyan-900',
//   'border-palette-cyan-800',
//   'border-palette-cyan-700',
//   'border-palette-cyan-500',
//   'border-palette-cyan-400',
//   'border-palette-cyan-300',
//   'border-palette-cyan-200',
//   'border-palette-cyan-100',
//   'border-palette-cyan-50',
//   'border-palette-cyan-25',
//   'border-palette-blue-600',
//   'border-palette-blue-950',
//   'border-palette-blue-900',
//   'border-palette-blue-800',
//   'border-palette-blue-700',
//   'border-palette-blue-500',
//   'border-palette-blue-400',
//   'border-palette-blue-300',
//   'border-palette-blue-200',
//   'border-palette-blue-100',
//   'border-palette-blue-50',
//   'border-palette-blue-25',
//   'border-palette-blue-dark-600',
//   'border-palette-blue-dark-950',
//   'border-palette-blue-dark-900',
//   'border-palette-blue-dark-800',
//   'border-palette-blue-dark-700',
//   'border-palette-blue-dark-500',
//   'border-palette-blue-dark-400',
//   'border-palette-blue-dark-300',
//   'border-palette-blue-dark-200',
//   'border-palette-blue-dark-100',
//   'border-palette-blue-dark-50',
//   'border-palette-blue-dark-25',
//   'border-palette-indigo-600',
//   'border-palette-indigo-950',
//   'border-palette-indigo-900',
//   'border-palette-indigo-800',
//   'border-palette-indigo-700',
//   'border-palette-indigo-500',
//   'border-palette-indigo-400',
//   'border-palette-indigo-300',
//   'border-palette-indigo-200',
//   'border-palette-indigo-100',
//   'border-palette-indigo-50',
//   'border-palette-indigo-25',
//   'border-palette-violet-600',
//   'border-palette-violet-950',
//   'border-palette-violet-900',
//   'border-palette-violet-800',
//   'border-palette-violet-700',
//   'border-palette-violet-500',
//   'border-palette-violet-400',
//   'border-palette-violet-300',
//   'border-palette-violet-200',
//   'border-palette-violet-100',
//   'border-palette-violet-50',
//   'border-palette-violet-25',
//   'border-palette-fuchsia-600',
//   'border-palette-fuchsia-950',
//   'border-palette-fuchsia-900',
//   'border-palette-fuchsia-800',
//   'border-palette-fuchsia-700',
//   'border-palette-fuchsia-500',
//   'border-palette-fuchsia-400',
//   'border-palette-fuchsia-300',
//   'border-palette-fuchsia-200',
//   'border-palette-fuchsia-100',
//   'border-palette-fuchsia-50',
//   'border-palette-fuchsia-25',
//   'border-palette-pink-600',
//   'border-palette-pink-950',
//   'border-palette-pink-900',
//   'border-palette-pink-800',
//   'border-palette-pink-700',
//   'border-palette-pink-500',
//   'border-palette-pink-400',
//   'border-palette-pink-300',
//   'border-palette-pink-200',
//   'border-palette-pink-100',
//   'border-palette-pink-50',
//   'border-palette-pink-25',
//   'border-palette-rose-600',
//   'border-palette-rose-950',
//   'border-palette-rose-900',
//   'border-palette-rose-800',
//   'border-palette-rose-700',
//   'border-palette-rose-500',
//   'border-palette-rose-400',
//   'border-palette-rose-300',
//   'border-palette-rose-200',
//   'border-palette-rose-100',
//   'border-palette-rose-50',
//   'border-palette-rose-25',
//   'border-palette-orange-600',
//   'border-palette-orange-950',
//   'border-palette-orange-900',
//   'border-palette-orange-800',
//   'border-palette-orange-700',
//   'border-palette-orange-500',
//   'border-palette-orange-400',
//   'border-palette-orange-300',
//   'border-palette-orange-200',
//   'border-palette-orange-100',
//   'border-palette-orange-50',
//   'border-palette-orange-25',
// ];

const baseBorderColors = [
  {
    id: 'border-transparent',
    value: 'transparent',
    label: 'Transparent',
  },
  // {
  //   id: 'border-brand-solid',
  //   value: '--border-brand-solid',
  //   label: 'Brand Solid',
  // },
  // {
  //   // todo: check this case, where border-brand-solid would be duplicated
  //   id: 'border-brand-solid',
  //   value: '--border-brand-solid',
  //   label: 'Brand Solid Alt',
  // },
  // {
  //   id: 'border-primary',
  //   value: '--border-primary',
  //   label: 'Primary',
  // },
  // {
  //   id: 'border-secondary',
  //   value: '--border-secondary',
  //   label: 'Secondary',
  // },
  // {
  //   id: 'border-tertiary',
  //   value: '--border-tertiary',
  //   label: 'Tertiary',
  // },
  // {
  //   id: 'border-success',
  //   value: '--border-success',
  //   label: 'Success',
  // },
  // {
  //   id: 'border-warning',
  //   value: '--border-warning',
  //   label: 'Warning',
  // },
  // {
  //   id: 'border-error',
  //   value: '--border-error',
  //   label: 'Error',
  // },
  {
    id: 'border-white',
    value: '--border-white',
    label: 'White',
  },
  {
    id: 'border-palette-common-black',
    value: '--palette-common-black',
    label: 'Black',
  },
];

export const primaryColor = [
  // gray colors
  { id: 'border-utility-gray-600', value: '--utility-gray-600', label: 'Gray 600' },
  { id: 'border-utility-gray-950', value: '--utility-gray-950', label: 'Gray 950' },
  { id: 'border-utility-gray-900', value: '--utility-gray-900', label: 'Gray 900' },
  { id: 'border-utility-gray-800', value: '--utility-gray-800', label: 'Gray 800' },
  { id: 'border-utility-gray-700', value: '--utility-gray-700', label: 'Gray 700' },
  { id: 'border-utility-gray-500', value: '--utility-gray-500', label: 'Gray 500' },
  { id: 'border-utility-gray-400', value: '--utility-gray-400', label: 'Gray 400' },
  {
    id: 'border-primary',
    value: '--border-primary',
    label: 'Gray 300',
  },
  {
    id: 'border-secondary',
    value: '--border-secondary',
    label: 'Gray 200',
  },
  {
    id: 'border-tertiary',
    value: '--border-tertiary',
    label: 'Gray 100',
  },
  { id: 'border-utility-gray-50', value: '--utility-gray-50', label: 'Gray 50' },
  { id: 'border-utility-gray-25', value: '--utility-gray-25', label: 'Gray 25' },

  // brand colors
  { id: 'border-utility-brand-600', value: '--utility-brand-600', label: 'Brand 600' },
  { id: 'border-utility-brand-950', value: '--utility-brand-950', label: 'Brand 950' },
  { id: 'border-utility-brand-900', value: '--utility-brand-900', label: 'Brand 900' },
  { id: 'border-utility-brand-800', value: '--utility-brand-800', label: 'Brand 800' },
  { id: 'border-utility-brand-700', value: '--utility-brand-700', label: 'Brand 700' },
  {
    id: 'border-brand-solid',
    value: '--border-brand-solid',
    label: 'Brand 500',
  },
  { id: 'border-utility-brand-400', value: '--utility-brand-400', label: 'Brand 400' },
  { id: 'border-utility-brand-300', value: '--utility-brand-300', label: 'Brand 300' },
  { id: 'border-utility-brand-200', value: '--utility-brand-200', label: 'Brand 200' },
  { id: 'border-utility-brand-100', value: '--utility-brand-100', label: 'Brand 100' },
  { id: 'border-utility-brand-50', value: '--utility-brand-50', label: 'Brand 50' },
  { id: 'border-utility-brand-25', value: '--utility-brand-25', label: 'Brand 25' },

  // brand secondary colors
  {
    id: 'border-utility-brand-secondary-600',
    value: '--palette-brand-secondary-600',
    label: 'Brand Secondary 600',
  },
  {
    id: 'border-utility-brand-secondary-950',
    value: '--palette-brand-secondary-950',
    label: 'Brand Secondary 950',
  },
  {
    id: 'border-utility-brand-secondary-900',
    value: '--palette-brand-secondary-900',
    label: 'Brand Secondary 900',
  },
  {
    id: 'border-utility-brand-secondary-800',
    value: '--palette-brand-secondary-800',
    label: 'Brand Secondary 800',
  },
  {
    id: 'border-utility-brand-secondary-700',
    value: '--palette-brand-secondary-700',
    label: 'Brand Secondary 700',
  },
  {
    id: 'border-utility-brand-secondary-500',
    value: '--palette-brand-secondary-500',
    label: 'Brand Secondary 500',
  },
  {
    id: 'border-utility-brand-secondary-400',
    value: '--palette-brand-secondary-400',
    label: 'Brand Secondary 400',
  },
  {
    id: 'border-utility-brand-secondary-300',
    value: '--palette-brand-secondary-300',
    label: 'Brand Secondary 300',
  },
  {
    id: 'border-utility-brand-secondary-200',
    value: '--palette-brand-secondary-200',
    label: 'Brand Secondary 200',
  },
  {
    id: 'border-utility-brand-secondary-100',
    value: '--palette-brand-secondary-100',
    label: 'Brand Secondary 100',
  },
  {
    id: 'border-utility-brand-secondary-50',
    value: '--palette-brand-secondary-50',
    label: 'Brand Secondary 50',
  },
  {
    id: 'border-utility-brand-secondary-25',
    value: '--palette-brand-secondary-25',
    label: 'Brand Secondary 25',
  },

  //success
  { id: 'border-utility-success-600', value: '--utility-success-600', label: 'Success 600' },
  { id: 'border-utility-success-950', value: '--utility-success-950', label: 'Success 950' },
  { id: 'border-utility-success-900', value: '--utility-success-900', label: 'Success 900' },
  { id: 'border-utility-success-800', value: '--utility-success-800', label: 'Success 800' },
  { id: 'border-utility-success-700', value: '--utility-success-700', label: 'Success 700' },
  { id: 'border-utility-success-500', value: '--utility-success-500', label: 'Success 500' },
  { id: 'border-utility-success-400', value: '--utility-success-400', label: 'Success 400' },
  {
    id: 'border-success',
    value: '--border-success',
    label: 'Success 300',
  },
  { id: 'border-utility-success-200', value: '--utility-success-200', label: 'Success 200' },
  { id: 'border-utility-success-100', value: '--utility-success-100', label: 'Success 100' },
  { id: 'border-utility-success-50', value: '--utility-success-50', label: 'Success 50' },
  { id: 'border-utility-success-25', value: '--utility-success-25', label: 'Success 25' },

  //error
  { id: 'border-utility-error-600', value: '--utility-error-600', label: 'Error 600' },
  { id: 'border-utility-error-950', value: '--utility-error-950', label: 'Error 950' },
  { id: 'border-utility-error-900', value: '--utility-error-900', label: 'Error 900' },
  { id: 'border-utility-error-800', value: '--utility-error-800', label: 'Error 800' },
  { id: 'border-utility-error-700', value: '--utility-error-700', label: 'Error 700' },
  { id: 'border-utility-error-500', value: '--utility-error-500', label: 'Error 500' },
  { id: 'border-utility-error-400', value: '--utility-error-400', label: 'Error 400' },
  {
    id: 'border-error',
    value: '--border-error',
    label: 'Error 300',
  },
  { id: 'border-utility-error-200', value: '--utility-error-200', label: 'Error 200' },
  { id: 'border-utility-error-100', value: '--utility-error-100', label: 'Error 100' },
  { id: 'border-utility-error-50', value: '--utility-error-50', label: 'Error 50' },
  { id: 'border-utility-error-25', value: '--utility-error-25', label: 'Error 25' },

  //warning
  { id: 'border-utility-warning-600', value: '--utility-warning-600', label: 'Warning 600' },
  { id: 'border-utility-warning-950', value: '--utility-warning-950', label: 'Warning 950' },
  { id: 'border-utility-warning-900', value: '--utility-warning-900', label: 'Warning 900' },
  { id: 'border-utility-warning-800', value: '--utility-warning-800', label: 'Warning 800' },
  { id: 'border-utility-warning-700', value: '--utility-warning-700', label: 'Warning 700' },
  { id: 'border-utility-warning-500', value: '--utility-warning-500', label: 'Warning 500' },
  { id: 'border-utility-warning-400', value: '--utility-warning-400', label: 'Warning 400' },
  {
    id: 'border-warning',
    value: '--border-warning',
    label: 'Warning 300',
  },
  { id: 'border-utility-warning-200', value: '--utility-warning-200', label: 'Warning 200' },
  { id: 'border-utility-warning-100', value: '--utility-warning-100', label: 'Warning 100' },
  { id: 'border-utility-warning-50', value: '--utility-warning-50', label: 'Warning 50' },
  { id: 'border-utility-warning-25', value: '--utility-warning-25', label: 'Warning 25' },
];

export const accentColors = [
  {
    id: 'border-utility-lime-600',
    value: '--utility-lime-600',
    label: 'Lime Green 600',
  },
  {
    id: 'border-utility-lime-950',
    value: '--utility-lime-950',
    label: 'Lime Green 950',
  },
  {
    id: 'border-utility-lime-900',
    value: '--utility-lime-900',
    label: 'Lime Green 900',
  },
  {
    id: 'border-utility-lime-800',
    value: '--utility-lime-800',
    label: 'Lime Green 800',
  },
  {
    id: 'border-utility-lime-700',
    value: '--utility-lime-700',
    label: 'Lime Green 700',
  },
  {
    id: 'border-utility-lime-500',
    value: '--utility-lime-500',
    label: 'Lime Green 500',
  },
  {
    id: 'border-utility-lime-400',
    value: '--utility-lime-400',
    label: 'Lime Green 400',
  },
  {
    id: 'border-utility-lime-300',
    value: '--utility-lime-300',
    label: 'Lime Green 300',
  },
  {
    id: 'border-utility-lime-200',
    value: '--utility-lime-200',
    label: 'Lime Green 200',
  },
  {
    id: 'border-utility-lime-100',
    value: '--utility-lime-100',
    label: 'Lime Green 100',
  },
  { id: 'border-utility-lime-50', value: '--utility-lime-50', label: 'Lime Green 50' },
  { id: 'border-utility-lime-25', value: '--utility-lime-25', label: 'Lime Green 25' },
  { id: 'border-utility-teal-600', value: '--utility-teal-600', label: 'Teal 600' },
  { id: 'border-utility-teal-950', value: '--utility-teal-950', label: 'Teal 950' },
  { id: 'border-utility-teal-900', value: '--utility-teal-900', label: 'Teal 900' },
  { id: 'border-utility-teal-800', value: '--utility-teal-800', label: 'Teal 800' },
  { id: 'border-utility-teal-700', value: '--utility-teal-700', label: 'Teal 700' },
  { id: 'border-utility-teal-500', value: '--utility-teal-500', label: 'Teal 500' },
  { id: 'border-utility-teal-400', value: '--utility-teal-400', label: 'Teal 400' },
  { id: 'border-utility-teal-300', value: '--utility-teal-300', label: 'Teal 300' },
  { id: 'border-utility-teal-200', value: '--utility-teal-200', label: 'Teal 200' },
  { id: 'border-utility-teal-100', value: '--utility-teal-100', label: 'Teal 100' },
  { id: 'border-utility-teal-50', value: '--utility-teal-50', label: 'Teal 50' },
  { id: 'border-utility-teal-25', value: '--utility-teal-25', label: 'Teal 25' },
  { id: 'border-utility-cyan-600', value: '--utility-cyan-600', label: 'Cyan 600' },
  { id: 'border-utility-cyan-950', value: '--utility-cyan-950', label: 'Cyan 950' },
  { id: 'border-utility-cyan-900', value: '--utility-cyan-900', label: 'Cyan 900' },
  { id: 'border-utility-cyan-800', value: '--utility-cyan-800', label: 'Cyan 800' },
  { id: 'border-utility-cyan-700', value: '--utility-cyan-700', label: 'Cyan 700' },
  { id: 'border-utility-cyan-500', value: '--utility-cyan-500', label: 'Cyan 500' },
  { id: 'border-utility-cyan-400', value: '--utility-cyan-400', label: 'Cyan 400' },
  { id: 'border-utility-cyan-300', value: '--utility-cyan-300', label: 'Cyan 300' },
  { id: 'border-utility-cyan-200', value: '--utility-cyan-200', label: 'Cyan 200' },
  { id: 'border-utility-cyan-100', value: '--utility-cyan-100', label: 'Cyan 100' },
  { id: 'border-utility-cyan-50', value: '--utility-cyan-50', label: 'Cyan 50' },
  { id: 'border-utility-cyan-25', value: '--utility-cyan-25', label: 'Cyan 25' },
  { id: 'border-utility-blue-600', value: '--utility-blue-600', label: 'Blue 600' },
  { id: 'border-utility-blue-950', value: '--utility-blue-950', label: 'Blue 950' },
  { id: 'border-utility-blue-900', value: '--utility-blue-900', label: 'Blue 900' },
  { id: 'border-utility-blue-800', value: '--utility-blue-800', label: 'Blue 800' },
  { id: 'border-utility-blue-700', value: '--utility-blue-700', label: 'Blue 700' },
  { id: 'border-utility-blue-500', value: '--utility-blue-500', label: 'Blue 500' },
  { id: 'border-utility-blue-400', value: '--utility-blue-400', label: 'Blue 400' },
  { id: 'border-utility-blue-300', value: '--utility-blue-300', label: 'Blue 300' },
  { id: 'border-utility-blue-200', value: '--utility-blue-200', label: 'Blue 200' },
  { id: 'border-utility-blue-100', value: '--utility-blue-100', label: 'Blue 100' },
  { id: 'border-utility-blue-50', value: '--utility-blue-50', label: 'Blue 50' },
  { id: 'border-utility-blue-25', value: '--utility-blue-25', label: 'Blue 25' },
  { id: 'border-utility-blue-dark-600', value: '--utility-blue-dark-600', label: 'Dark Blue 600' },
  { id: 'border-utility-blue-dark-950', value: '--utility-blue-dark-950', label: 'Dark Blue 950' },
  { id: 'border-utility-blue-dark-900', value: '--utility-blue-dark-900', label: 'Dark Blue 900' },
  { id: 'border-utility-blue-dark-800', value: '--utility-blue-dark-800', label: 'Dark Blue 800' },
  { id: 'border-utility-blue-dark-700', value: '--utility-blue-dark-700', label: 'Dark Blue 700' },
  { id: 'border-utility-blue-dark-500', value: '--utility-blue-dark-500', label: 'Dark Blue 500' },
  { id: 'border-utility-blue-dark-400', value: '--utility-blue-dark-400', label: 'Dark Blue 400' },
  { id: 'border-utility-blue-dark-300', value: '--utility-blue-dark-300', label: 'Dark Blue 300' },
  { id: 'border-utility-blue-dark-200', value: '--utility-blue-dark-200', label: 'Dark Blue 200' },
  { id: 'border-utility-blue-dark-100', value: '--utility-blue-dark-100', label: 'Dark Blue 100' },
  { id: 'border-utility-blue-dark-50', value: '--utility-blue-dark-50', label: 'Dark Blue 50' },
  { id: 'border-utility-blue-dark-25', value: '--utility-blue-dark-25', label: 'Dark Blue 25' },
  { id: 'border-utility-indigo-600', value: '--utility-indigo-600', label: 'Indigo 600' },
  { id: 'border-utility-indigo-950', value: '--utility-indigo-950', label: 'Indigo 950' },
  { id: 'border-utility-indigo-900', value: '--utility-indigo-900', label: 'Indigo 900' },
  { id: 'border-utility-indigo-800', value: '--utility-indigo-800', label: 'Indigo 800' },
  { id: 'border-utility-indigo-700', value: '--utility-indigo-700', label: 'Indigo 700' },
  { id: 'border-utility-indigo-500', value: '--utility-indigo-500', label: 'Indigo 500' },
  { id: 'border-utility-indigo-400', value: '--utility-indigo-400', label: 'Indigo 400' },
  { id: 'border-utility-indigo-300', value: '--utility-indigo-300', label: 'Indigo 300' },
  { id: 'border-utility-indigo-200', value: '--utility-indigo-200', label: 'Indigo 200' },
  { id: 'border-utility-indigo-100', value: '--utility-indigo-100', label: 'Indigo 100' },
  { id: 'border-utility-indigo-50', value: '--utility-indigo-50', label: 'Indigo 50' },
  { id: 'border-utility-indigo-25', value: '--utility-indigo-25', label: 'Indigo 25' },
  { id: 'border-utility-violet-600', value: '--utility-violet-600', label: 'Violet 600' },
  { id: 'border-utility-violet-950', value: '--utility-violet-950', label: 'Violet 950' },
  { id: 'border-utility-violet-900', value: '--utility-violet-900', label: 'Violet 900' },
  { id: 'border-utility-violet-800', value: '--utility-violet-800', label: 'Violet 800' },
  { id: 'border-utility-violet-700', value: '--utility-violet-700', label: 'Violet 700' },
  { id: 'border-utility-violet-500', value: '--utility-violet-500', label: 'Violet 500' },
  { id: 'border-utility-violet-400', value: '--utility-violet-400', label: 'Violet 400' },
  { id: 'border-utility-violet-300', value: '--utility-violet-300', label: 'Violet 300' },
  { id: 'border-utility-violet-200', value: '--utility-violet-200', label: 'Violet 200' },
  { id: 'border-utility-violet-100', value: '--utility-violet-100', label: 'Violet 100' },
  { id: 'border-utility-violet-50', value: '--utility-violet-50', label: 'Violet 50' },
  { id: 'border-utility-violet-25', value: '--utility-violet-25', label: 'Violet 25' },
  { id: 'border-utility-fuchsia-600', value: '--utility-fuchsia-600', label: 'Fuchsia 600' },
  { id: 'border-utility-fuchsia-950', value: '--utility-fuchsia-950', label: 'Fuchsia 950' },
  { id: 'border-utility-fuchsia-900', value: '--utility-fuchsia-900', label: 'Fuchsia 900' },
  { id: 'border-utility-fuchsia-800', value: '--utility-fuchsia-800', label: 'Fuchsia 800' },
  { id: 'border-utility-fuchsia-700', value: '--utility-fuchsia-700', label: 'Fuchsia 700' },
  { id: 'border-utility-fuchsia-500', value: '--utility-fuchsia-500', label: 'Fuchsia 500' },
  { id: 'border-utility-fuchsia-400', value: '--utility-fuchsia-400', label: 'Fuchsia 400' },
  { id: 'border-utility-fuchsia-300', value: '--utility-fuchsia-300', label: 'Fuchsia 300' },
  { id: 'border-utility-fuchsia-200', value: '--utility-fuchsia-200', label: 'Fuchsia 200' },
  { id: 'border-utility-fuchsia-100', value: '--utility-fuchsia-100', label: 'Fuchsia 100' },
  { id: 'border-utility-fuchsia-50', value: '--utility-fuchsia-50', label: 'Fuchsia 50' },
  { id: 'border-utility-fuchsia-25', value: '--utility-fuchsia-25', label: 'Fuchsia 25' },
  { id: 'border-utility-pink-600', value: '--utility-pink-600', label: 'Pink 600' },
  { id: 'border-utility-pink-950', value: '--utility-pink-950', label: 'Pink 950' },
  { id: 'border-utility-pink-900', value: '--utility-pink-900', label: 'Pink 900' },
  { id: 'border-utility-pink-800', value: '--utility-pink-800', label: 'Pink 800' },
  { id: 'border-utility-pink-700', value: '--utility-pink-700', label: 'Pink 700' },
  { id: 'border-utility-pink-500', value: '--utility-pink-500', label: 'Pink 500' },
  { id: 'border-utility-pink-400', value: '--utility-pink-400', label: 'Pink 400' },
  { id: 'border-utility-pink-300', value: '--utility-pink-300', label: 'Pink 300' },
  { id: 'border-utility-pink-200', value: '--utility-pink-200', label: 'Pink 200' },
  { id: 'border-utility-pink-100', value: '--utility-pink-100', label: 'Pink 100' },
  { id: 'border-utility-pink-50', value: '--utility-pink-50', label: 'Pink 50' },
  { id: 'border-utility-pink-25', value: '--utility-pink-25', label: 'Pink 25' },
  { id: 'border-utility-rose-600', value: '--utility-rose-600', label: 'Rose 600' },
  { id: 'border-utility-rose-950', value: '--utility-rose-950', label: 'Rose 950' },
  { id: 'border-utility-rose-900', value: '--utility-rose-900', label: 'Rose 900' },
  { id: 'border-utility-rose-800', value: '--utility-rose-800', label: 'Rose 800' },
  { id: 'border-utility-rose-700', value: '--utility-rose-700', label: 'Rose 700' },
  { id: 'border-utility-rose-500', value: '--utility-rose-500', label: 'Rose 500' },
  { id: 'border-utility-rose-400', value: '--utility-rose-400', label: 'Rose 400' },
  { id: 'border-utility-rose-300', value: '--utility-rose-300', label: 'Rose 300' },
  { id: 'border-utility-rose-200', value: '--utility-rose-200', label: 'Rose 200' },
  { id: 'border-utility-rose-100', value: '--utility-rose-100', label: 'Rose 100' },
  { id: 'border-utility-rose-50', value: '--utility-rose-50', label: 'Rose 50' },
  { id: 'border-utility-rose-25', value: '--utility-rose-25', label: 'Rose 25' },
  { id: 'border-utility-orange-600', value: '--utility-orange-600', label: 'Orange 600' },
  { id: 'border-utility-orange-950', value: '--utility-orange-950', label: 'Orange 950' },
  { id: 'border-utility-orange-900', value: '--utility-orange-900', label: 'Orange 900' },
  { id: 'border-utility-orange-800', value: '--utility-orange-800', label: 'Orange 800' },
  { id: 'border-utility-orange-700', value: '--utility-orange-700', label: 'Orange 700' },
  { id: 'border-utility-orange-500', value: '--utility-orange-500', label: 'Orange 500' },
  { id: 'border-utility-orange-400', value: '--utility-orange-400', label: 'Orange 400' },
  { id: 'border-utility-orange-300', value: '--utility-orange-300', label: 'Orange 300' },
  { id: 'border-utility-orange-200', value: '--utility-orange-200', label: 'Orange 200' },
  { id: 'border-utility-orange-100', value: '--utility-orange-100', label: 'Orange 100' },
  { id: 'border-utility-orange-50', value: '--utility-orange-50', label: 'Orange 50' },
  { id: 'border-utility-orange-25', value: '--utility-orange-25', label: 'Orange 25' },
];

export const borderColors = [
  ...baseBorderColors.map((color) => ({ ...color, subGroupId: 'whiteBlack' })),
  ...primaryColor.map((color) => ({ ...color, subGroupId: 'primaryColor' })),
  ...accentColors.map((color) => ({ ...color, subGroupId: 'accentColor' })),
];

// export const gradientColor = [
//   {
//     id: 'gradient-brand',
//     value: '--gradient-brand',
//     label: 'Primary Brand',
//   },
//   {
//     id: 'gradient-primary',
//     value: '--gradient-primary',
//     label: 'Primary Gradient',
//   },
//   {
//     id: 'gradient-error',
//     value: '--gradient-error',
//     label: 'Error Gradient',
//   },
//   {
//     id: 'gradient-warning',
//     value: '--gradient-warning',
//     label: 'Warning Gradient',
//   },

//   {
//     id: 'gradient-success',
//     value: '--gradient-success',
//     label: 'Success Gradient',
//   },
//   {
//     id: 'gradient-secondary',
//     value: '--gradient-secondary',
//     label: 'Secondary Gradient',
//   },
//   {
//     id: 'gradient-tertiary',
//     value: '--gradient-tertiary',
//     label: 'Tertiary Gradient',
//   },
//   {
//     id: 'gradient-neutral',
//     value: '--gradient-neutral',
//     label: 'Neutral Gradient',
//   },
//   {
//     id: 'gradient-cool',
//     value: '--gradient-cool',
//     label: 'Cool Gradient',
//   },
//   {
//     id: 'gradient-light',
//     value: '--gradient-light',
//     label: 'Light Gradient',
//   },
//   {
//     id: 'gradient-blue',
//     value: '--gradient-blue',
//     label: 'Blue Gradient',
//   },
//   {
//     id: 'gradient-yellow',
//     value: '--gradient-yellow',
//     label: 'Yellow Gradient',
//   },
//   {
//     id: 'gradient-red',
//     value: '--gradient-red',
//     label: 'Red Gradient',
//   },
//   {
//     id: 'bg-rainbow',
//     value: '--gradient-rainbow',
//     label: 'Rainbow Gradient',
//   },
// ];

export const borderColorGroups: ColorGroups[] = [
  {
    id: 'borderColor',
    label: 'Solid',
    subGroups: [
      {
        id: 'whiteBlack',
        label: '',
        hideDivider: true,
        className: 'pb-xs',
      },
      {
        id: 'primaryColor',
        label: '',
      },
      {
        id: 'accentColor',
        label: '',
      },
    ],
    colors: borderColors,
  },
];
